define(["./create", "./RequestError"], function (create, RequestError) {
  // module:
  //		dojo/errors/RequestTimeoutError

  /*=====
	 return function(){
		 // summary:
		 //		TODOC
	 };
	 =====*/

  return create('RequestTimeoutError', null, RequestError, {
    dojoType: 'timeout'
  });
});



//////////////////
// WEBPACK FOOTER
// ./src/lib/dojo/errors/RequestTimeoutError.js
// module id = 87
// module chunks = 0